import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hour4u-admin-job-post',
  templateUrl: './job-post.component.html',
  styleUrls: ['./job-post.component.scss']
})
export class JobPostComponent implements OnInit {
  projectId: string;
  profile = this.appService.getCurrentAccount();
  projectDetails: any;
  icp_profile: any = {};
  roleSummary: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private jobService: JobService,
    private appService: AppService,
    private notify: NotificationService
  ) { }

  ngOnInit() {
    var self = this;
    this.route.params.subscribe(function (data) {
      self.projectId = data.id;
      self.fetchProject();
    });
  }

  fetchProject() {
    var self = this;
    this.jobService.getHoaProject(this.profile.entity.id, this.projectId).subscribe(
      function (result) {
        self.projectDetails = result;
        var icp = (self.projectDetails && self.projectDetails.icp_profile) ? self.projectDetails.icp_profile : {};
        self.icp_profile = {
          position: (icp.position && icp.position.value) ? icp.position.value : '',
          location: (icp.location && icp.location.value) ? icp.location.value : '',
          salary_range: (icp.salary_range && icp.salary_range.value) ? icp.salary_range.value : '',
          type: (icp.type && icp.type.value) ? icp.type.value : '',
          experience: (icp.experience && icp.experience.value) ? icp.experience.value : ''
        };
        self.roleSummary = self.projectDetails && self.projectDetails.project_description_new ? self.projectDetails.project_description_new : '';
      },
      function (err) {
        console.error("Error fetching project after WS parsing success:", err);
      }
    );
  }

  // Add a method to prepare icp_profile for saving (if needed)
  prepareIcpProfileForSave() {
    return {
      position: { value: this.icp_profile.position, weight: 0.33 },
      location: { value: this.icp_profile.location, weight: 0.33 },
      salary_range: { value: this.icp_profile.salary_range, weight: 0.33 },
      type: { value: this.icp_profile.type, weight: 0.33 },
      experience: { value: this.icp_profile.experience, weight: 0.33 }
    };
  }

  getIcpProfileForSave() {
    const result: any = {};
    Object.keys(this.icp_profile).forEach(key => {
      if (this.icp_profile[key] && this.icp_profile[key].trim() !== '') {
        result[key] = { value: this.icp_profile[key] };
      }
    });
    return result;
  }

  updateICP() {
    const icpToSend = this.getIcpProfileForSave();

    this.jobService.updateICP(this.profile.entity.id, this.projectId, icpToSend).subscribe(
      (res) => {
        console.log('ICP updated successfully:', res);
        this.router.navigate([`/job/view-new-project/${this.projectDetails.project_id}/setup-workflow`]);
      },
      (err) => {
        console.error('❌ Failed to update ICP', err);
      }
    );
  }

  copyApplicationLink(event: Event) {
    event.stopPropagation();
    this.updateICP();

    const url = environment.production
      ? `https://apply.houseofagents.ai/?project_id=${this.projectDetails.project_id}&entity_id=${this.profile.entity.id}`
      : `https://apply-dev.houseofagents.ai/?project_id=${this.projectDetails.project_id}&entity_id=${this.profile.entity.id}`;

    navigator.clipboard.writeText(url).then(() => {
      console.log('Link copied:', url);
      this.notify.showMessage(
        "Link copied",
        5000,
        'assets/tick-circle.svg',
        `Share URL with leads to allow them to submit resume!`
      );
    }).catch(err => {
      console.error('Failed to copy link:', err);
    });
  }
}
